module.exports = __webpack_public_path__ + "img/dropdown-arrow.ba49d087.svg";